export default __webpack_public_path__ + "static/media/DSC05956.a1ddc289.jpg";